<div class="machine-card">
  <div class="header">
    @if (showCompleteCard()) {
      <div class="row-lg-center-center">
        <div class="row-center-center">
          <p class="pt-3">
            <b>
              {{ currentProductionCard()?.productionCardNumber }}
            </b>
          </p>
        </div>

        @if (showProcessTimer()) {
          <div class="row-sm-start-center border rounded-lg p-3">
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-orange-600" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clip-rule="evenodd"
                />
              </svg>
            </i>
            <span>Processing: {{ processElapsedTime() }}</span>
          </div>
        }

        @if (showWaitingTimer()) {
          <div class="row-sm-start-center border rounded-lg p-3">
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clip-rule="evenodd"
                />
              </svg>
            </i>
            <span>Finished: {{ processFinishedTime() }}</span>
          </div>
        }
      </div>
    } @else {
      @if (asset()) {
        <p class="w-full p-3 rounded bg-black text-white text-center text-xl font-bold">{{ asset()?.assetId }} : {{ asset()?.name }}</p>
      }
    }
  </div>
  <div class="body">
    <div
      class="col-lg py-5"
      [ngClass]="{
        'w-1/5': showCompleteCard(),
      }"
    >
      <!-- !PC DETAILS   -->
      @if (showCompleteCard()) {
        <div class="grid-2">
          <div class="span-1">
            <p class="text-gray-400 font-bold">Client</p>
            <p>
              {{ getClient(currentWorkOrder()!) }}
            </p>
          </div>
          <div class="span-1">
            <p class="text-gray-400 font-bold">Brand</p>
            <p>
              {{ getBrand(currentWorkOrder()!) }}
            </p>
          </div>
          <div class="span-1">
            <p class="text-gray-400 font-bold">Client PO</p>
            <p>
              {{ clientPO }}
            </p>
          </div>
          <div class="span-1">
            <p class="text-gray-400 font-bold">Work Order</p>
            <p>
              {{ currentWorkOrder()?.orderNumber }}
            </p>
          </div>
        </div>

        <div class="col">
          <div class="">
            <p class="text-gray-400 font-bold">Route:</p>
            <p>
              @if (finishingRouteProductionCard()) {
                {{ finishingRouteProductionCard()?.number }}
              }
            </p>
          </div>
          <div class="">
            <p class="text-gray-400 font-bold">Fabric:</p>
            @if (currentWorkOrder()?.fabrics) {
              <ul>
                @for (fabric of currentWorkOrder()?.fabrics; track fabric.id) {
                  <li>{{ fabric.fabric.fieldToDisplay || fabric.fabricCode }} - {{ getFabricFormLabel(fabric.fabric.fabricForm) }}</li>
                }
              </ul>
            }
          </div>
          <div class="">
            <p class="text-gray-400 font-bold">Processes:</p>
            @if (finishingRouteProductionCard()) {
              <ul>
                @for (route of finishingRouteProductionCard()?.route; track route.processId) {
                  <li>{{ localeHelperService.getLocalizedValue(route.processName) }}</li>
                }
              </ul>
            }
          </div>
        </div>
      } @else {
        <div class="col">
          <div class="">
            <p class="text-gray-400 font-bold">Description:</p>
            <p>
              @if (asset()) {
                {{ asset()?.description }}
              }
            </p>
          </div>
          <div class="">
            <p class="text-gray-400 font-bold">Processes:</p>
            @if (asset()) {
              <ul>
                @for (process of asset()?.scanningStationDetails?.processNames; track process.processId) {
                  <li>{{ localeHelperService.getLocalizedValue(process.processName) }}</li>
                }
              </ul>
            }
          </div>
        </div>
      }

      <!-- !STATE ROUTE -->
      @if (showCompleteCard()) {}
    </div>
  </div>
  <div class="footer">
    @if (!showCompleteCard()) {
      <button class="w-full text-center p-3 border rounded-lg font-bold text-blue-500" (click)="redirectMachine(asset()!.assetId!)">Show more</button>
    } @else {
      @if (finishingRouteProductionCard()) {
        <div class="w-full bg-slate-100 p-5 rounded-lg">
          <p-timeline [value]="finishingRouteProductionCard()?.route" layout="horizontal" align="top" class="w-full" styleClass="w-full">
            <ng-template let-process pTemplate="content">
              {{ localeHelperService.getLocalizedValue(process.processName) }}
            </ng-template>
          </p-timeline>
        </div>
      }
    }
  </div>
</div>
